import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';

var Parse = require('parse');
Parse.initialize(process.env.REACT_APP_PARSE_APP_ID, {});  // APP_ID, JAVASCRIPT_KEY
Parse.serverURL = process.env.REACT_APP_PARSE_ENDPOINT;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
